import styled from 'styled-components';
import {tokens} from "../../../theme";

export const FileSelectionItemsGridContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
`;

export const SourceSection = styled.div`
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
`;

export const SourceHeader = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 3rem;
    align-items: center;
    margin-bottom: 12px;
    padding: 8px 0;
`;


export const SourceName = styled.h4`
    font-size: ${tokens.fontSize.base};
    font-weight: ${tokens.fontWeight.medium};
    color: ${({theme}) => theme.palette.text.primary};
    margin: 0;
    flex-shrink: 0;
`;

export const SourceActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
    white-space: nowrap;
`;

export const SourceCheckboxLabel = styled.label`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: ${tokens.fontSize.sm};
    color: ${({theme}) => theme.palette.text.hint};
    cursor: pointer;
    flex-shrink: 0;
`;

export const EmptyState = styled.div`
    margin-bottom: 30px;
    padding: 16px;
    text-align: center;
    color: ${({theme}) => theme.palette.text.hint};
`;

export const EmptyStateText = styled.p`
    font-size: ${tokens.fontSize.sm};
    margin: 0;
`;

export const FilesGrid = styled.div`
    display: grid;
    flex: 1;
    min-height: 0;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    align-items: start;
    align-content: start;
    gap: 12px;
    margin-bottom: 16px;
`;


export const FilesListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
`;

export const FileSelectionPaginationWrapper = styled.div`
    display: flex;
    flex: 0;
    align-items: baseline;
    justify-content: space-between;
    border-top: 1px solid #E2E8F0;
    flex-wrap: wrap;
    gap: 12px;
`;

export const PaginationLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const PaginationRight = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledPageSizeLabel = styled.p`
    padding: 6px;
    font-size: ${tokens.fontSize.base};
`;